export const dataAssetFormData = (dropdownAssetKategori) => {
  return [
    {
      id: "id_asset_kategori",
      label: "Pilih Asset Kategori",
      fields: [
        {
          type: "option",
          options: dropdownAssetKategori,
        },
      ],
    },
    {
      id: "nama_asset",
      label: "Nama Asset",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Nama Asset..",
        },
      ],
    },
    {
      id: "sumber_asset",
      label: "Sumber Asset",
      fields: [
        {
          type: "option",
          options: [
            {
              label: "Operasional",
              value: "Operasional",
            },
            {
              label: "Investasi",
              value: "Investasi",
            },
            {
              label: "Hibah",
              value: "Hibah",
            },
          ],
        },
      ],
    },
    {
      id: "tgl_perolehan",
      label: "Tanggal Perolehan",
      fields: [
        {
          type: "date",
          placeholder: "Masukan Tanggal Perolehan",
        },
      ],
    },
    {
      id: "nilai_perolehan",
      label: "Nilai Perolehan",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Nilai Perolehan",
        },
      ],
    },
    {
      id: "umur_ekonomis",
      label: "Umur Ekonomis",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Umur Ekonomis",
        },
      ],
    },
    {
      id: "persen_penyusutan",
      label: "Persen Penyusutan",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Persen Penyusutan (0-100)",
        },
      ],
    },
    {
      id: "bukti_asset",
      label: "Bukti Asset (.jpg / .png / .jpeg) (Optional)",
      fields: [
        {
          type: "file",
        },
      ],
    },
  ];
};
